import { render, staticRenderFns } from "./secondLevelOption.view.vue?vue&type=template&id=38b47e4b&scoped=true&lang=pug"
import script from "./secondLevelOption.view.vue?vue&type=script&lang=ts"
export * from "./secondLevelOption.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b47e4b",
  null
  
)

export default component.exports